import { ObjectFieldValueFragment } from '../../../__generated__/graphql';
import { EmployeeRelatedListRecord } from '../../EmployeeData/types';

// Maps a related-list record's fields onto the ObjectFieldValueFragment shape
// the Request Form modal already consumes for Employee data-change requests,
// filtered by the selected Request Form's allowed field names.
export function buildRecordFieldsOverride(
  record: EmployeeRelatedListRecord,
  allowedFieldNames: ReadonlyArray<string>,
  objectType: string,
): ObjectFieldValueFragment[] {
  const allowed = new Set(allowedFieldNames);
  return record.fields
    .filter((field) => allowed.has(field.fieldInfo.name))
    .map((field) => ({
      __typename: 'ObjectFieldValue',
      value: field.value,
      fieldInfo: {
        __typename: 'FieldInfo',
        objectType,
        name: field.fieldInfo.name,
        label: field.fieldInfo.label,
        locale: '',
        recordTypeId: null,
        type: field.fieldInfo.type,
        picklistValues: field.fieldInfo.options.map((option) => ({
          __typename: 'PickListEntry',
          label: option.label,
          value: option.value,
        })),
      },
    }));
}
